<template>
<div>
<v-progress-circular v-if="loading" indeterminate v-bind:size="70" v-bind:width="7" class="purple--text"></v-progress-circular>
<v-layout column>
<v-flex xs12>
    <v-toolbar class="indigo" dark>
        <v-toolbar-title>Verstorbene In Bearbeitung</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch v-if="currentUser.group === 'admin'" class="mt-5 mr-5" :label="switchSearch ? 'Nach Verstorbenen filtern' : 'Nach Mitarbeiter filtern'" v-model="switchSearch"></v-switch>
        <v-btn-toggle v-if="!switchSearch" class="pa-0 ma-0" v-model="userSelected">
            <v-btn :value="user.name" v-for="user in usersList" :key="user.id" color="primary">{{user.name}}</v-btn>
        </v-btn-toggle>
        <v-text-field v-else class="mt-5 ml-5" style="max-width:200px" placeholder="Nach Namen filtern" v-model="search" prepend-icon="mdi-magnify"></v-text-field>

      </v-toolbar>
      <v-container fluid grid-list-xl style="font-size: 16px">
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 lg6 xl4 v-for="defunt in defuntsFilter" :key="defunt.id_defunt">
            <v-card hover @click.stop.native="defSelected(defunt.id_defunt)" height="300px">
                <v-card-title style="font-size: 18px" :class="defunt.sexe=='Féminin' ? 'pink white--text' : 'blue white--text'">
                    <span v-text="defunt.titre + ' ' + defunt.prenom + ' ' + defunt.nom" style="font-weight: 500"></span>
                    <v-spacer></v-spacer>
                    <v-chip v-if="currentUser.group === 'admin'" color="primary lighten-4" outlined pill>
                        <v-icon left>mdi-account-outline</v-icon>
                        {{defunt.createdByName}}
                    </v-chip>
                    <v-spacer></v-spacer>
                    <span>{{defunt.num}}</span>
                </v-card-title>
                <v-container fluid>
                    <v-layout row>
                        <v-flex xs10>
                            <div>{{defunt.ceremonieQuand}}</div>
                            <div v-if="defunt.ceremonieQuand!='Sans cérémonie'">{{defunt.ceremonieLieu}}</div>
                            <v-divider style="margin:5px 0px"></v-divider>
                            <div>{{defunt.veillanceQuand}}</div>
                            <div v-if="defunt.veillanceQuand!='Sans veillée, sans présence'">{{defunt.veillanceLieu}}</div>
                            <v-divider style="margin:5px 0px"></v-divider>
                            <div v-if="defunt.incInh!='inhumation'">{{defunt.inhCendresQuand}}</div>
                            <div v-if="defunt.incInh!='inhumation' && defunt.inhCendresQuand!='Les cendres seront confiés à la famille'">{{defunt.inhCendresLieu}}</div>
                        </v-flex>
                        <v-flex xs2>
                            <v-img :src="'/PHP/ajax/getPics.php?name=' + defunt.photo" height="150px"></v-img>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-container>
                    <v-layout row>
                        <v-flex xs12>
                            <v-footer absolute style="z-index:1">
                                <img v-if="defunt.incInh=='incineration'" src="../assets/logoInc.png" alt="symbole incinération" height="40px">
                                <img v-if="defunt.incInh=='inhumation'" src="../assets/logoInh.png" alt="symbole inhumation" height="40px">
                                <img v-if="defunt.incInh=='aquamation'" src="../assets/logoAqua.png" alt="symbole aquamation" height="40px">
                                <v-spacer></v-spacer>
                                 <v-tooltip v-if="defunt.remarque!=''" bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-on="on" v-bind="attrs" @click.stop="showRemarque(defunt.remarque)" icon dark color="deep-orange"><v-icon>mdi-clipboard-text</v-icon></v-btn>
                                  </template>
                                    <span>{{defunt.remarque}}</span>
                                </v-tooltip>
                                <v-spacer></v-spacer>
                                <v-btn @click.stop.native="defClick('contact', defunt.id_defunt)" icon color="indigo">
                                    <v-icon>mdi-account-box</v-icon>
                                </v-btn>
                                <v-btn @click.stop.native="defClick('services', defunt.id_defunt)" text icon color="indigo">
                                    <v-icon>mdi-room-service</v-icon>
                                </v-btn>
                                <v-btn @click.stop.native="defClick('avis', defunt.id_defunt)" text icon color="indigo">
                                    <v-icon>mdi-text-subject</v-icon>
                                </v-btn>
                                <v-btn text @click.stop.native="defClick('devis', defunt.id_defunt)" icon color="indigo">
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                                <v-btn @click.stop.native="defClick('check', defunt.id_defunt)" text icon color="indigo">
                                    <v-icon>mdi-check-circle</v-icon>
                                </v-btn>
                            </v-footer>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

</v-flex>
</v-layout>
<v-dialog v-model="dialogRemarque" max-width="500px">
    <v-card>
    <v-card-title>
        <span>Bemerkung</span>
    </v-card-title>
    <v-card-text>
    {{remarque}}
    </v-card-text>
    <v-card-actions>
        <v-btn color="primary" text @click.stop="dialogRemarque=false">Schließen</v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</div>
</template>
<script>
   import {ajax_post} from '../../public/global.js'
   import currentUser from "../store/currentUser"
   export default {
        data(){
            return{
                loading: false,
                show: false,
                defunts: [],
                dialogRemarque: false,
                remarque: '',
                search: '',
                currentUser: currentUser.user,
                usersList: {},
                userSelected: '',
                switchSearch: true
            }
        },
        methods: {
            fetchData() {
                this.loading = true
                this.recupAllUsers()
                ajax_post(`/PHP/ajax/returnDefs.php`, `token=${this.$token()}`).then((response) =>{
                    
                    let ceremonieQuand
                    let veillanceQuand
                    let inhCendresQuand
                    let ceremonieLieu
                    let veillanceLieu
                    let inhCendresLieu

                    let rep = JSON.parse(response)
                    rep.data.forEach(elem => {
                        console.log(elem.ceremonie_lieu)
                        ceremonieLieu = (elem.ceremonie_lieu=='' | elem.ceremonie_lieu== null ? 'Lieu de cérémonie pas défini' : elem.ceremonie_lieu + (elem.ceremonie_loc=='' ? '' : ' à ' + elem.ceremonie_loc))
                        veillanceLieu = (elem.veillance_lieu=='' | elem.veillance_lieu== null ? 'Lieu de veillée ou présence pas défini' : elem.veillance_lieu)
                        inhCendresLieu = (elem.lieu_inh_cendres=='' | elem.lieu_inh_cendres==null ? "Lieu d'inhumation des cendres pas défini" : elem.lieu_inh_cendres)

                        
                        if(elem.ceremonie != 0 && elem.ceremonie != null){
                            if(elem.ceremonie_date == null){
                                ceremonieQuand = 'Cérémonie le ???'
                            }else{
                                if(elem.ceremonie_heure == null){
                                    ceremonieQuand = 'Cérémonie le ' + (new Date(elem.ceremonie_date + 'T' + '00:00:00')).toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ???'
                                }else{
                                    ceremonieQuand = 'Cérémonie le ' + (new Date(elem.ceremonie_date + 'T' + '00:00:00')).toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ' + elem.ceremonie_heure.substring(5,0).replace(':','h')
                                }
                            }
                        }else{
                            if(elem.ceremonie==0){
                                ceremonieQuand = 'Sans cérémonie'
                            }
                            if(elem.ceremonie == null){
                                ceremonieQuand = 'Cérémonie pas encore défini'
                            }
                        }

                        

                        if(elem.veillance != 'sans' && elem.veillance != null && elem.veillance != ""){
                            if(elem.veillance == 'veille'){
                                if(elem.veillance_date == null){
                                    veillanceQuand = 'Veillée de prières le ???'
                                }else{
                                    if(elem.veillance_heure == null){
                                        veillanceQuand ='Veillée de prières le ' + (new Date(elem.veillance_date + 'T' + '00:00:00')).toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ???'
                                    }else{
                                        veillanceQuand ='Veillée de prières le ' + (new Date(elem.veillance_date + 'T' + '00:00:00')).toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ' + elem.veillance_heure.substring(5,0).replace(':','h')
                                    }
                                }
                            }
                            if(elem.veillance == 'presence'){
                                if(elem.veillance_date == null){
                                    veillanceQuand = 'Présence le ???'
                                }else{
                                    if(elem.veillance_heure == null | elem.veillance_heure_fin==null){
                                        veillanceQuand ='Présence ' + (new Date(elem.veillance_date + 'T' + '00:00:00')).toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ???'
                                    }else{
                                        veillanceQuand ='Présence ' + (new Date(elem.veillance_date + 'T' + '00:00:00')).toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' de ' + elem.veillance_heure.substring(5,0).replace(':','h') + ' à ' + elem.veillance_heure_fin.substring(5,0).replace(':','h')
                                    }
                                }
                            }

                        }else{
                            if(elem.veillance == 'sans'){
                                veillanceQuand = 'Sans veillée, sans présence'
                            }else{
                                veillanceQuand = 'Veillée ou présence pas encore défini'
                            }
                        }

                        if(elem.cendres_famille==1){
                            inhCendresQuand = 'Les cendres seront confiés à la famille'
                        }else if (elem.cendres_famille == null){
                            inhCendresQuand = 'Cendres pas encore défini'
                        }else{
                            if(elem.date_inh_cendres == null){
                                inhCendresQuand = 'Inhumation des cendres le ???'
                            }else{
                                if(elem.heure_inh_cendres == null){
                                    inhCendresQuand = 'Inhumation des cendres le ' + (new Date(elem.date_inh_cendres + 'T' + '00:00:00')).toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ???'
                                }else{
                                    inhCendresQuand = 'Inhumation des cendres le ' + (new Date(elem.date_inh_cendres + 'T' + '00:00:00')).toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ' + elem.heure_inh_cendres.substring(5,0).replace(':','h')
                                }
                            }
                        }
                        this.defunts.push({id_defunt: elem.id, num: elem.num, sexe: elem.sexe, nom: elem.nom, prenom: elem.prenom, titre: elem.titre, photo: elem.photo, remarque: elem.remarque, ceremonieQuand: ceremonieQuand, ceremonieLieu: ceremonieLieu, veillanceQuand: veillanceQuand, veillanceLieu: veillanceLieu, incInh: elem.inc_inh, inhCendresQuand: inhCendresQuand, inhCendresLieu: inhCendresLieu, createdByName: elem.name})
                    })

                })
                this.loading = false
            },
            defSelected(id){
                this.$router.push({name: 'defuntInfo', params: {id: id}})
            },
            defClick(choice, id){
                if(choice=='contact'){
                    this.$router.push({name: 'contact', params: {id: id}})
                }
                if(choice=='services'){
                    this.$router.push({name: 'servicesFunebres', params: {id: id}})
                }
                if(choice=='avis'){
                    this.$router.push({name: 'avisMortuaire', params: {id: id}})
                }
                if(choice=='devis'){
                    this.$router.push({name: 'devis', params: {id: id}})
                }
                if(choice=='check'){
                    this.$router.push({name: 'recap', params: {id: id}})
                }
            },
            showRemarque(remarque){

                this.dialogRemarque = true
                this.remarque = remarque
            },
            recupAllUsers(){
                ajax_post(`/PHP/ajax/returnAllUsers.php`, `token=${this.$token()}`).then((response)=>{
                    let rep = JSON.parse(response)
                    if(!rep.error){
                      this.usersList = rep.data
                    }else{
                      this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                    }
                })
            }
        },
        created() {
            this.fetchData()
        },
        computed: {
            defuntsFilter() {
                let self = this
                if(self.switchSearch){
                    return this.defunts.filter(elem => elem.nom.toLowerCase().indexOf(self.search) > -1)
                }else{
                    return this.defunts.filter(elem => elem.createdByName.indexOf(self.userSelected) > -1)
                }
            }
        },
        watch: {
            '$route': 'fetchData'
        }
    }
</script>